import { configureStore } from '@reduxjs/toolkit'
import AuthReducer from '../reducer/AuthSlice';
import OpenentryReducer from '../reducer/OpenentrySlice';

export const store = configureStore({
    reducer: {
        auth: AuthReducer,
        openentry: OpenentryReducer
    }
})